<template>
    <el-dialog top="30px" title="库存详情" :visible.sync="dialogVisible" width="60%">
        <div class="box-card" v-if="Object.keys(infoData).length">
            <el-row class="custom-container">
                <el-col :span="4">
                    <el-image
                        style="width: 100%; height: 100%;"
                        :src="infoData.imagesList[0]"
                        :preview-src-list="infoData.imagesList"
                    ></el-image>
                </el-col>
                <el-col :span="18" :offset="2">
                    <div class="inform flex">
                        <div class="title">库存编号：</div>
                        <div>{{ infoData.inventoryNumber }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">公司：</div>
                        <div>{{ infoData.branchCompanyName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">全称：</div>
                        <div>{{ infoData.productFullName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">简称：</div>
                        <div>{{ infoData.productSimpleName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">描述：</div>
                        <div>{{ infoData.productDescription }}</div>
                    </div>
                          <div class="inform flex">
                        <div class="title">规格尺寸：</div>
                        <div>{{ infoData.inventorySku }}</div>
                    </div>
                    <el-row type="flex" justify="space-between">
                        <div class="inform flex">
                            <div class="title">库存数量：</div>
                            <div>{{infoData.actualCount}}</div>
                        </div>
                        <!-- <el-button type="primary" @click="BarCode">条线码打印</el-button> -->
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div v-if="str.rid == '1'">
            <el-divider></el-divider>
            <div class="custom-container">
                <div style="width:100%;">
                    <el-row>
                        <el-col :span="3">
                            <div class="inform" v-if="JSON.stringify(infoPurchase)!=='{}'">申请数量：{{ infoPurchase.actualCount }}</div>
                            <div class="inform" v-if="JSON.stringify(infoPurchase)=='{}'">申请数量：{{infoData.actualCount}}</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="inform">仓库名称：{{infoData.warehouseName}}</div>
                        </el-col>
                        <el-col :span="6" v-if="NumVisible!=1">
                            <span class="inform">货架：</span>
                            <el-select :placeholder="infoData.shelfNumber" allow-create filterable  v-model="formData.shelves" value-key="id">
                                <el-option
                                    v-for="item in listShelves"
                                    :key="item.id"
                                    :label="item.shelfNumber"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-button v-if="NumVisible!=1" type="primary" @click="infoCheckDone" :loading="isDoneBtnLoding" style="margin-left:120px">确认</el-button>
                    </el-row>
                </div>
            </div>
        </div>
        <el-divider></el-divider>
        <div>
            <h4>出入库记录</h4>
            <el-table :data="listTable" border>
                <el-table-column prop="inventoryNumber" width="200" label="库存编号" align="center"></el-table-column>
                <el-table-column label="图片" width="120" align="center">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="right" style="float: left;" v-if="scope.row.imagesList">
                            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
                            <div class="scope_img" slot="reference">
                                <img :src="scope.row.imagesList[0]" alt />
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="productFullName" min-width="200" label="全称" align="center"></el-table-column>
                <el-table-column prop="averageWeight" width="200" label="平均计费重" align="center"></el-table-column>
                <el-table-column prop="productType" width="200" label="货物类型" align="center"></el-table-column>
                <el-table-column width="80" label="类型" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.operateType === 1">入库</div>
                        <div v-else-if="scope.row.operateType === 2">出库</div>
                        <div v-else-if="scope.row.operateType === 3">销毁</div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" width="200" label="入库时间" align="center"></el-table-column>
                <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
                <el-table-column width="200" prop="ziName" label="所属公司" align="center">
                    <template slot-scope="scope">
                        <div>
                            <span>{{ scope.row.branchCompanyName }}</span>
                            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
                            <span>{{ scope.row.subCompanyName }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="80" align="center">
                    <template slot-scope="scope">
                        <!-- <i class="el-icon-edit-outline fontSize-30" @click="InLibrary(scope.row)"></i> -->
                        <i
                            class="el-icon-edit-outline fontSize-30"
                            v-if="scope.row.operateType === 1"
                           
                        ></i>
                         <!-- @click="Application_for_export(scope.row)" -->
                        <i
                            class="el-icon-edit-outline fontSize-30"
                            v-else-if="scope.row.operateType === 2"
                           
                        ></i>
                         <!-- @click="Application_for_warehousing(scope.row)" -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
           <div style="margin-top:20px;" v-if="NumVisible==1">
              <el-table  ref="multipleTable" height="250" :data="EditTableData" tooltip-effect="dark" style="width: 100%"  border>
                <el-table-column label="批次号" prop="inventoryBatchNo" align="center"></el-table-column>
                <el-table-column label="预计库存" prop="predictCount"  align="center"></el-table-column>
                <el-table-column label="实际库存" prop="actualCount"  align="center"></el-table-column>
                <el-table-column label="销毁数/退件数" prop="actualCount"  align="center">
                	<template slot-scope="scope">
							{{ scope.row.destroyCount }}/{{scope.row.returnCount}}
						</template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime"  align="center"></el-table-column>
                <el-table-column label="创建人"  align="center">
                    	<template slot-scope="scope">
							{{ scope.row.userName }}-{{scope.row.roleName}}
						</template>
                        </el-table-column>
                  
              </el-table>
          </div>
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "Library",
    data() {
        return {
            NumVisible:null,
            dialogVisible: false,
            infoData: {},
            listTable: [],
            EditTableData:[],
            EditTable:{
                    inventoryNumber:""
                },
            isDoneBtnLoding: false,

            infoPurchase: {},
            listWarehouse: [],
            listShelves: [],
            formData: {
                warehouse: "",
                shelves: {},
            },
            paramsData:{},
        };
    },
    created(){
        this.formData.shelves = null
        this.str = JSON.parse(localStorage.getItem("role"));
    },
    methods: {
        init(row,num) { 
            // console.log(row)
            this.NumVisible = num;
            this.dialogVisible = true;
               this.EditTable.inventoryNumber = row.inventoryNumber;
            this.infoData = row;
            this.getListTable();
            // this.getPurchaseInfo();
            this.getWarehouseList();
            this.getShelvesList();
            // console.log(row.shelfNumber)
            this.formData.shelves = {
                    shelfNumber:row.shelfNumber
            }
            this.listShelves = []
        },
        close() {
            this.dialogVisible = false;
            this.isDoneBtnLoding = false;
            this.infoData = {};
        },
        // selectBlur(e) {
            // this.formData.shelves = e.target.value
            // console.log(this.formData.shelves)
        // },
        getListTable() {
            const API = Baseurl + "inventoryController/getInventoryOperateByInventoryId";
            const paramsData = {
                inventoryId: this.infoData.id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listTable = data;
                }
            });
            ajaxPost(Baseurl+"inventoryController/getInventoryBatchsByInventoryNumber",this.EditTable).then(res=>{
          this.EditTableData = res.data.data
      })
        },
        getPurchaseInfo() {
            const API = Baseurl + "inventoryController/getPurchaseByInventoryId";
            const paramsData = {
                inventoryId: this.infoData.inventoryId,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.infoPurchase = data || {};
                }
            });
        },
        infoCheckDone() {
            const { warehouse, shelves } = this.formData;
            console.log(shelves)
            // console.log(this.infoData.shelfNumber)
            if (shelves.shelfNumber==null) {
                this.$message.warning("请先选择货架");
                return;
            }
            // return;
            // console.log(JSON.parse(JSON.stringify(this.infoData)))
            this.isDoneBtnLoding = true;
            const paramsData = {
                warehouseName: this.infoData.warehouseName,
                shelfType: this.infoData.shelfType,
                shelfNumber: shelves.shelfNumber,
                // inventoryId: this.infoData.inventoryId,
                id: this.infoData.id,
                // operateType: this.infoData.operateType
            };
            this.paramsData = paramsData;
            // console.log(paramsData)
            // console.log(this.paramsData)
            this.$emit("confirm", paramsData);
        },
        getWarehouseList() {
            if (this.listWarehouse.length) return;
            const API = Baseurl + "inventoryController/getWarehouseList";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listWarehouse = data;
                    this.formData.warehouse = data[0];
                    if (Object.keys(this.formData.warehouse).length) this.getShelvesList();
                }
            });
        },
        getShelvesList() {
            if (!Object.keys(this.formData.warehouse).length) return;
            const API = Baseurl + "inventoryController/getShelfsByWarehouseId";
            const paramsData = {
                warehouseId: this.formData.warehouse.id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listShelves = data;
                    // console.log(this.listShelves)
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.custom-container {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
.scope_img {
    img {
        width: 100px;
        height: 100px;
    }
}
.prduct_img {
    width: 500px;
    height: 500px;
}
</style>
